export default __webpack_public_path__ + "static/media/HDFC_Life_Logo.980242af.png";